import numeral from 'numeral';
import {ObjectHasProperty, NormalizeClassNameString, ToString, RoundExt} from './utils';

const EmailBlurOptions = {doLTrim: true, doRTrim: true};
const PasswordBlurOptions = null; //{doLTrim: true, doRTrim: true};

/*
    options.isNumber - covert text value to number
    options.min - min number value if defined (valid only if options.isNumber)
    options.max - max number value if defined (valid only if options.isNumber)
    options.precision - precision of number value (default - 0, valid only if options.isNumber)
    options.doLTrim - left trim text value (valid only if not options.isNumber)
    options.doRTrim - right trim text value (valid only if not options.isNumber)
*/
export function CreateInputValueHandler(onChange) {
    
    const result = new function() {
        const _self = this;

        let _onChange = onChange;
        let _onChangeOptions = {};
        let _onBlurOptions = {};

        const _getInputValueOptions = (event, options) => {
            const target = event.target;
            const name = target.name || target.id;
            const eventType = event.type || 'change';

            if (!Boolean(options)) {
                switch (eventType) {
                    case 'change':
                        options = _onChangeOptions[name];
                        break;
                    case 'blur':
                        options = _onBlurOptions[name] || _onChangeOptions[name];
                        break;
                }
            }

            if (!Boolean(options)) {
                switch (target.type) {
                    case 'email':
                        if (eventType === 'blur') {
                            options = EmailBlurOptions;
                        }

                        break;
                    case 'number':
                        options = {
                            isNumber: true,
                            min: target.min,
                            max: target.max
                        };
                        break;
                    case 'password':
                        if (eventType === 'blur') {
                            options = PasswordBlurOptions;
                        }

                        break;
                }
            }
    
            const opt = {...options};
            
            opt.isNumber = Boolean(opt.isNumber);
            opt.doLTrim = Boolean(opt.doLTrim);
            opt.doRTrim = Boolean(opt.doRTrim);
            if (opt.isNumber) {
                opt.precision = parseInt(opt.precision) || 0;
            }
            
            return opt;
        }
    
        const _getInputValueFromEvent = (event, options) => {
            const opt = _getInputValueOptions(event, options);
            var value = undefined;
    
            const target = event.target;
    
            if (ObjectHasProperty(target, 'checked')) {
                value = target.checked;
            }
            else if (opt.isNumber) {
                const min = parseFloat(opt.min);
                const max = parseFloat(opt.max);
                const decSep = (0.1).toLocaleString()[1];
                
                let strValue = ToString(target.value).trim().replace(decSep, '.');
                value = RoundExt(numeral(strValue).value() || 0, opt.precision);
                if (!isNaN(min)){
                    value = Math.max(RoundExt(min, opt.precision), value);
                }
                if (!isNaN(max)){
                    value = Math.min(RoundExt(max, opt.precision), value);
                }
            }
            else {
                value = (target.value || '');
                if (opt.doLTrim) {
                    value = value.trimLeft();
                }
                if (opt.doRTrim) {
                    value = value.trimRight();
                }
            }
    
            if (typeof opt.converter === 'function') {
                value = opt.converter(value);
            }

            return value;
        }

        const _handleInputChange = (event, options) => {
            const opt = _getInputValueOptions(event, options);
            const value = _getInputValueFromEvent(event, opt);
    
            const target = event.target;
            const name = opt.name || target.name || target.id;
    
            if ((event.type == 'blur') && opt.isNumber) {
                target.value = value.toFixed(opt.precision);
            }
    
            if (typeof _onChange === 'function') {
                _onChange(name, value, event, opt);
            }
        }
    
        const _getControlClass = (errorName, errors, className) => {
            let result = (className || '');
            const errorNames = (errorName || '').trim().split(' ');
            
            if (Boolean(errors) && errorNames.some(errorName => ObjectHasProperty(errors, errorName) && Boolean(errors[errorName]))) {
                result += ' is-invalid';
            }

            return NormalizeClassNameString(result);
        }
    
        const _getControlError = (errorName, errors) => {
            let result = '';
            const errorNames = (errorName || '').trim().split(' ');
    
            if (errors) {
                result = errorNames
                    .map(errorName => {
                        let error = '';
                        
                        if (ObjectHasProperty(errors, errorName)) {
                            error = errors[errorName];
                        }
    
                        return error;
                    })
                    .filter(p => (p))
                    .join('\n');
            }
    
            return result;
        }
    
        const _preventDefault = event => {
            event?.preventDefault();
        }

        Object.defineProperties(
            _self, 
            { 
                'handleInputChange': {
                    get: () => _handleInputChange,
                },
                'getControlClass': {
                    get: () => _getControlClass,
                },
                'getControlError': {
                    get: () => _getControlError,
                },
                'getInputValueOptions': {
                    get: () => _getInputValueOptions,
                },
                'getInputValueFromEvent': {
                    get: () => _getInputValueFromEvent,
                },
                'onChange' : {
                    get: () => _onChange,
                    set: (v) => _onChange = v
                },
                'onChangeOptions' : {
                    get: () => _onChangeOptions,
                    set: (v) => _onChangeOptions = v || {}
                },
                'onBlurOptions' : {
                    get: () => _onBlurOptions,
                    set: (v) => _onBlurOptions = v || {}
                },
                'preventDefault': {
                    get: () => _preventDefault,
                }
            });
    }

    return result;
}